export default __webpack_public_path__ + "static/media/icon-brand-google-pay.a93bd6c1.svg";